
export const formatToStringISODate = (date: Date | null | undefined) => {

  if (date === undefined || date === null)
    return '';

  const d: Date = new Date(date);

  return d.getFullYear()
    + "-" + (((d.getMonth() + 1) < 10) ? "0" : "") + (d.getMonth() + 1)
    + "-" + ((d.getDate() < 10) ? "0" : "") + d.getDate()
    ;
};

export const formatToEuroDate = (date: Date | null) => {

  if (date === undefined || date === null)
    return '';

  const d: Date = new Date(date);

  return ((d.getDate() < 10) ? "0" : "") + d.getDate()
    + "." + (((d.getMonth() + 1) < 10) ? "0" : "") + (d.getMonth() + 1)
    + "." + d.getFullYear()
    ;
};

export const formatToEuroDateTime = (date: Date | null) => {
  if (date === null)
    return '';

  const datum = formatToEuroDate(date);

  const d: Date = new Date(date);
  var second2 = "" + d.getSeconds();
  var minute2 = "" + d.getMinutes();
  var hour2 = "" + d.getHours();

  if (second2.length === 1) second2 = "0" + second2;
  if (minute2.length === 1) minute2 = "0" + minute2;
  if (hour2.length === 1) hour2 = "0" + hour2;

  return datum + ` ${hour2}:${minute2}`;
};



/*export const formatToISODateTimeIfArray = (date: Date | null) => {
  if (date === null)
    return '';

  const dateArray = date.toString().split(",")

  if (!dateArray || dateArray.length < 3) return "";

  const [year, month, day, hour, minute, second] = dateArray;

  var second2 = second;
  var minute2 = minute;
  var hour2 = hour;

  if (second2.length === 1) second2 = "0" + second2;
  if (minute2.length === 1) minute2 = "0" + minute2;
  if (hour2.length === 1) hour2 = "0" + hour2;

  return `${String(day).padStart(2, "0")}.${String(month).padStart(2, "0")}.${year} ${hour2}:${minute2}:${second}`;
};*/

/*export const formatToEuroDateIfArray = (date: Date | null) => {

  if (date === undefined || date === null)
    return '';

  const dateArray = date.toString().split(",")

  if (!dateArray || dateArray.length < 3) return "";

  const [year, month, day] = dateArray;
  return `${String(day).padStart(2, "0")}.${String(month).padStart(2, "0")}.${year}`;
};*/


export const getWochentagUtil = (date: Date | string | undefined) => {
  if (!date) return "";
  const d = typeof date === "string" ? new Date(date) : date;
  const options: Intl.DateTimeFormatOptions = { weekday: 'short' };
  return d.toLocaleDateString('de-DE', options) + ", ";
}
